<script>
import { ScCard, ScIcon } from '@intelipost-js/secure-components';

export default {
  name: 'NewBillingTemplateImageHelper',
  components: { ScCard, ScIcon },
};
</script>

<template>
  <sc-card class="image-container" style="background-color: #FAFBFB">
    <template slot="body">
      <section class="text-content">
        <div class="text-content__icon">
          <sc-icon icon="far fa-info-circle" size="is-small" />
        </div>
        <div class="text-content__message">
          <p>
            Para identificar a linha do cabeçalho de sua fatura é simples,
            o cabeçalho é onde está o título das informações dos pedidos da cobrança.
          </p>
          <p>
            No exemplo abaixo, o cabeçalho <strong>está na linha 2 da planilha.</strong>
          </p>
        </div>
      </section>
      <section class="image-content">
        <img src="/static/images/audit/helper-1.5x.png" alt="Exemplo de fatura">
      </section>
    </template>
  </sc-card>
</template>

<style scoped lang="scss">
.image-container {
  border-style: solid;
  border-width: 1px;
  border-radius: 8px;
  border-color: #3670D6;

  .text-content {
    display: flex;
    align-items: baseline;
    margin-bottom: 1rem;

    &__message {
      line-height: 16px;
    }

    &__icon {
      margin: 5px;
      color: #3670D6;
    }
  }

  .image-content {
    img {
      border-radius: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/NewBillingTemplateImageHelper.vue